exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".K5rx8ii8nnunTTwKjORw3{font-size:15px!important}html[dir] .K5rx8ii8nnunTTwKjORw3{padding-bottom:8px}", ""]);
// Exports
exports.locals = {
	"header": "K5rx8ii8nnunTTwKjORw3"
};